
namespace GeniuzPOS.LogManage {

    @Serenity.Decorators.registerClass()
    export class LogJsonGrid extends Serenity.EntityGrid<LogJsonRow, any> {
        protected getColumnsKey() { return LogJsonColumns.columnsKey; }
        protected getDialogType() { return LogJsonDialog; }
        protected getIdProperty() { return LogJsonRow.idProperty; }
        protected getInsertPermission() { return LogJsonRow.insertPermission; }
        protected getLocalTextPrefix() { return LogJsonRow.localTextPrefix; }
        protected getService() { return LogJsonService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getButtons() {
			var button = super.getButtons();

            button.splice(Q.indexOf(button, x => x.cssClass == "add-button"), 1);
            
            button.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: LogJsonService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));
                
                button.push(
                    {
                        title: Q.text("Close"), // *** Get button text from translation
                        cssClass: '.panel-titlebar-close',
                        icon: 'fa-close',
                        onClick: () => {
                            window.location.href = '/';
                            return false;
                        },
                    }
                );

                
			// button.splice(Q.indexOf(button, x => x.cssClass == "add-button"), 1);
			return button;
		}
    }
}